<div fxLayout="column">
  <mat-card class="mb-3" fxLayout="column">
    <mat-card-header>
      <mat-card-title>Søjlevisninger</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mt-3">
      <button mat-stroked-button (click)="openCreateDisplayDialog()">
        Opret ny
      </button>
    </mat-card-content>

  </mat-card>

  @if (displays) {
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="100" fxLayoutGap="2rem grid"
      [@listAnimation]="displays.length"
      >
      @for (display of displays; track display) {
        <div fxFlex="33">
          <mat-card fxFlex>
            <mat-card-title-group>
              <mat-card-title>
                {{display.name}}
              </mat-card-title>
              <div fxLayoutAlign="end start">
                <button mat-icon-button class="mr-3" matTooltip="Rediger" color="accent" (click)="openEditDisplayDialog(display)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="accent" matTooltip="Slet" (click)="deleteDisplay(display)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-card-title-group>
            <mat-card-content>
              <p>
                Ejer af visning: {{display.user_initials}}
              </p>
              @if (display.shared) {
                <p>
                  Visningen er delt med alle
                </p>
              }
              @if (!display.shared) {
                <p>
                  Visningen er ikke delt
                </p>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  }

</div>
